import format from "date-fns/format";

export default function formatTime(time: Date) {
  return format(time, "HH:mm");
}
